import { Data } from "../assets/content/Data.jsx";
import { Outline } from "../assets/content/Outline";
import { useParams, useNavigate } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet-async";
import "../assets/css/style.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const TutorialsBody = () => {
  const param = useParams();
  const navigate = useNavigate();

  function next() {
    const currentIndex = Outline.find(i => i.link === param.topic)?.index;
    if (currentIndex !== undefined) {
      const nextItem = Outline[currentIndex + 1];
      if (nextItem) navigate(`/data-structures/${nextItem.link}`);
    }
  }

  function previous() {
    const currentIndex = Outline.find(i => i.link === param.topic)?.index;
    if (currentIndex !== undefined) {
      const previousItem = Outline[currentIndex - 1];
      if (previousItem) navigate(`/data-structures/${previousItem.link}`);
    }
  }

  return (
    <>
      {Data.filter(elem => elem.link === param.topic).map((element) => (
        <React.Fragment key={element.title}>

          {/* ⭐⭐⭐ SEO goes here! */}
          <Helmet>
            <title>{element.title} in Data Structures: Guide for Beginners | Easy Data Structures</title>

            <meta
              name="description"
              content={
                element.description ||
                `Learn ${element.title} with animations, examples, and explanations.`
              }
            />

            <link
              rel="canonical"
              href={`https://easydatastructures.com/data-structures/${element.link}`}
            />
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/",
            "logo": "https://easydatastructures.com/easyDS-easydatastructures-logo.webp",
            "sameAs": [
                "https://www.facebook.com/EasyDataStructures",
                "https://www.instagram.com/easydatastructures",
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "Person",
            "name": "Madan Lal",
            "url": "https://madanlal1.github.io/Profile-Portfolio/",
            "image": "https://avatars.githubusercontent.com/u/81483460?v=4",
            "sameAs": [
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]  
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "Easy Data Structures",
            "url": `https://easydatastructures.com/data-structures/${element.link}`,
            "potentialAction": {
                "@type": "SearchAction",
                "target": `https://easydatastructures.com/data-structures/${element.link}`+"/search?q=keyword{search_term_string}",
                "query-input": "required name=search_term_string"
            }
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What is Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Easy Data Structures is an online platform that provides simple explanations, visuals, tutorials, and real-world examples of data structures and algorithms to help students and developers learn quickly."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Who can learn from Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The website is designed for beginners, computer science students, job seekers preparing for technical interviews, and developers who want to refresh their knowledge of data structures."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Are the tutorials suitable for coding interview preparation?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, the tutorials and examples on Easy Data Structures cover the core concepts frequently asked in technical interviews, including arrays, linked lists, stacks, queues, trees, graphs, and algorithms."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Is Easy Data Structures free to use?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, all the explanations and learning material on Easy Data Structures are freely available for students and developers."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Which data structures can I learn on this website?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can learn core data structures such as arrays, linked lists, stacks, queues, trees, heaps, hash tables, graphs, and more, along with visual examples and use cases."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Does Easy Data Structures offer real-world examples?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, each topic includes simple, real-world examples to help you understand how data structures are used in actual applications."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can beginners understand the explanations easily?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely. The content is written in simple language with diagrams and step-by-step explanations, making it ideal for beginners."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Do I need coding experience to start?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No prior coding experience is required. The website starts with the basics and gradually introduces you to more advanced concepts."
                    }
                }
                ]
            }
            )}
            </script>
          </Helmet>
          {/* END SEO TAGS */}

          <h1 className="tutorial-title">{element.title}</h1>

          <div className="ratio ratio-16x9">
            <iframe
              title={element.title}
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${element.video}`}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>

          <br />

          <div>{element.content1}</div>

          <br />

          <button
            onClick={previous}
            disabled={element.link === "data-structure"}
            className="btn btn-primary"
            id="left"
          >
            <i className="bi bi-arrow-left-circle"></i> Previous
          </button>

          <button
            onClick={next}
            disabled={element.link === "separate-chaining"}
            className="btn btn-primary"
            id="right"
          >
            Next <i className="bi bi-arrow-right-circle"></i>
          </button>

        </React.Fragment>
      ))}
    </>
  );
};

export default TutorialsBody;